import { GroupSetting } from '@griply/types';
import { createContext, useContext } from 'react';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';
import { Task } from 'shared/types/task';

export type LifeAreaRenderData = {
  groupSettings: GroupSetting;
  tasksMap: Record<ID, Task>;
  tasks: Task[];
  lifeAreasMap: Record<ID, LifeArea>;
  lifeAreas: LifeArea[];
  goals: Goal[];
  today: Date;
  denseFormat?: boolean;
  defaultNewTaskDate?: Date;
};

export const LifeAreaRenderDataContext =
  createContext<LifeAreaRenderData | null>(null);

export const useLifeAreaRenderData = (): LifeAreaRenderData => {
  const data = useContext(LifeAreaRenderDataContext);
  if (!data) {
    throw new Error(
      'useLifeAreaRenderData must be used within a LifeAreaGroupingTasksList',
    );
  }
  return data;
};
